import React from 'react';
import '../../styles/HeroSection.css';
import bannerImage from '../../../images/HomePage/Mr.Sea_HomePage_HeroImage.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-section__banner">
        <img src={bannerImage} alt="Luxury Boat Rental Experience"/>
      </div>
      <div className="hero-section__content">
        <h1>Boat Rentals in Miami, FL</h1>
        <p>Your Miami boat day starts here… explore our full fleet now. 
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
